









































































import Vue from 'vue';
import { LOGOUT } from '../use-cases/user-auth/AuthModule';
import { LOGIN, RED_MAT_CALCULATIONS } from '../router/route-names';

export default Vue.extend({
  props: {
    source: String,
  },
  data() {
    return {
      drawer: null,
      year: new Date().getFullYear(),
      calculationsRoute: RED_MAT_CALCULATIONS,
    };
  },
  computed: {
    isAdmin(): boolean {
      return this.$store.getters.userRole === 'Admin';
    },
  },
  methods: {
    onClickLogout() {
      this.$store.dispatch(LOGOUT);
      this.$router.push({ name: LOGIN });
    },
  },
});
